import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logoImage from '../../assets/images/logo-lingland.png';
import { Menu, X, Upload } from 'lucide-react'; // Dodano ikony Menu i X
import './Header.css';

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Efekt do zamykania menu przy zmianie trasy (jeśli kliknięto link w menu)
  // oraz do blokowania scrolla tła, gdy menu jest otwarte
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden'; // Blokuj scroll tła
    } else {
      document.body.style.overflow = 'unset'; // Odblokuj scroll
    }
    // Cleanup function to reset overflow when component unmounts or menu closes
    return () => {
        document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);


  // Zamykaj menu po kliknięciu linku (dla SPA)
   const handleLinkClick = () => {
     if (isMobileMenuOpen) {
       setIsMobileMenuOpen(false);
     }
   };

  return (
    <header className={`app-header sticky ${isMobileMenuOpen ? 'mobile-menu-is-open' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>
            <img src={logoImage} alt="Lingland Logo" className="logo-img" />
          </Link>
        </div>

        {/* Nawigacja desktopowa */}
        <nav className="main-nav desktop-nav">
          <ul>
            <li><NavLink to="/" end onClick={handleLinkClick}>Strona Główna</NavLink></li>
            <li><NavLink to="/uslugi" onClick={handleLinkClick}>Usługi</NavLink></li>
            <li><NavLink to="/cennik" onClick={handleLinkClick}>Cennik</NavLink></li>
            <li><NavLink to="/jak-to-dziala" onClick={handleLinkClick}>Jak to działa</NavLink></li>
            <li><NavLink to="/o-nas" onClick={handleLinkClick}>O nas</NavLink></li>
            <li><NavLink to="/blog" onClick={handleLinkClick}>Blog</NavLink></li>
            <li><NavLink to="/kontakt" onClick={handleLinkClick}>Kontakt</NavLink></li>
          </ul>
        </nav>

        {/* CTA Desktopowe */}
        <div className="header-cta desktop-cta">
          <Link to="/wycena" className="button-outline-primary header-button" onClick={handleLinkClick}>
            Wyceń tłumaczenie
          </Link>
        </div>

        {/* Przycisk Hamburgera (Mobile) */}
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen}>
          {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>

        {/* Panel Menu Mobilnego */}
        <div className={`mobile-menu-panel ${isMobileMenuOpen ? 'is-open' : ''}`}>
          <nav className="mobile-nav">
            <ul>
               <li><NavLink to="/" end onClick={handleLinkClick}>Strona Główna</NavLink></li>
               <li><NavLink to="/uslugi" onClick={handleLinkClick}>Usługi</NavLink></li>
               <li><NavLink to="/cennik" onClick={handleLinkClick}>Cennik</NavLink></li>
               <li><NavLink to="/jak-to-dziala" onClick={handleLinkClick}>Jak to działa</NavLink></li>
               <li><NavLink to="/o-nas" onClick={handleLinkClick}>O nas</NavLink></li>
               <li><NavLink to="/blog" onClick={handleLinkClick}>Blog</NavLink></li>
               <li><NavLink to="/kontakt" onClick={handleLinkClick}>Kontakt</NavLink></li>
            </ul>
          </nav>
          <div className="mobile-menu-cta">
            <Link to="/wycena" className="button-primary mobile-cta-button" onClick={handleLinkClick}>
              <Upload size={18} style={{ marginRight: '0.5rem' }}/> Wyceń Tłumaczenie
            </Link>
          </div>
        </div>
        {/* Nakładka na tło przy otwartym menu */}
        {isMobileMenuOpen && <div className="mobile-menu-overlay" onClick={toggleMobileMenu}></div>}

      </div>
    </header>
  );
}

export default Header;